import { render, staticRenderFns } from "./copyItemMasterTable.vue?vue&type=template&id=6179d1d1&scoped=true&"
import script from "./copyItemMasterTable.vue?vue&type=script&lang=js&"
export * from "./copyItemMasterTable.vue?vue&type=script&lang=js&"
import style0 from "./copyItemMasterTable.vue?vue&type=style&index=0&id=6179d1d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6179d1d1",
  null
  
)

export default component.exports